import { render, staticRenderFns } from "./FarmerRow.vue?vue&type=template&id=b8414968&"
import script from "./FarmerRow.vue?vue&type=script&lang=js&"
export * from "./FarmerRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports